/* eslint-disable
    @typescript-eslint/no-this-alias,
    eqeqeq,
    @typescript-eslint/no-use-before-define,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import { Analytics, formatContainers } from '@trello/atlassian-analytics';
import { forTemplate } from '@trello/i18n';

import { CardMemberSelectView } from 'app/scripts/views/card/CardMemberSelectView';
import { ComposerPosSelectorView } from 'app/scripts/views/card-composer/ComposerPosSelectorView';
import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PopoverSelectorMenuTemplate } from 'app/scripts/views/templates/PopoverSelectorMenuTemplate';
import { ComponentWrapper } from 'app/src/components/ComponentWrapper';
import { LazyCardComposerLabelsPopover } from 'app/src/components/LabelsPopover';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const formatLabelsPopover = forTemplate('labels_popover');

interface ComposerSelectorMenuView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  modelCache: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class ComposerSelectorMenuView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Co... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'options';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'Composer... Remove this comment to see the full error message
    this.prototype.events = {
      'click .js-mem-selector': 'openMemSelector',
      'click .js-label-selector': 'openLabelSelector',
      'click .js-pos-selector': 'openPosSelector',
    };
  }

  initialize() {
    Analytics.sendScreenEvent({
      name: 'cardComposerMenuInlineDialog',
      containers: formatContainers({
        idBoard: this.model?.getBoard()?.id,
        idList: this.model?.attributes?.list?.id,
        idOrganization: this.model?.getBoard()?.getOrganization()?.id,
      }),
    });
  }

  render() {
    this.$el.html(
      PopoverSelectorMenuTemplate({
        isTemplate: this.model.board.isTemplate(),
      }),
    );

    return this;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openMemSelector(e: any) {
    stopPropagationAndPreventDefault(e);
    return PopOver.pushView({
      view: CardMemberSelectView,
      options: { model: this.model, modelCache: this.modelCache },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openLabelSelector(e: any) {
    stopPropagationAndPreventDefault(e);

    const board = this.model.getBoard();
    const idBoard = board?.id;
    const idOrganization = board?.getOrganization()?.id;
    const idCard = this.model.id;
    const idList = this.model.getList()?.id;

    PopOver.pushView({
      getViewTitle: () => formatLabelsPopover('labels'),
      reactElement: (
        <ComponentWrapper>
          <LazyCardComposerLabelsPopover
            idBoard={idBoard}
            idOrganization={idOrganization}
            idList={idList}
            model={this.model}
          />
        </ComponentWrapper>
      ),
    });
    Analytics.sendScreenEvent({
      name: 'labelsInlineDialog',
      containers: formatContainers({
        idBoard,
        idOrganization,
        idCard,
        idList,
      }),
      attributes: { source: 'cardComposerMenuInlineDialog' },
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  openPosSelector(e: any) {
    stopPropagationAndPreventDefault(e);
    return PopOver.pushView({
      view: ComposerPosSelectorView,
      options: { model: this.model, modelCache: this.modelCache },
    });
  }
}

ComposerSelectorMenuView.initClass();
export { ComposerSelectorMenuView };
